import type * as lazyIndex from "./lazyIndex";
import { LazyModule, LazyAction } from "owa-bundling";

const lazyModule: LazyModule<typeof lazyIndex> = new LazyModule(() => import(/* webpackChunkName: "GroupsPanelContent"*/ "./lazyIndex"), { name: "GroupsPanelContent" });

export const lazySelectTabInPanel: LazyAction<typeof lazyIndex.selectTabInPanel, typeof lazyModule> = new LazyAction(lazyModule, m => m.selectTabInPanel);

export const lazySelectGroupInPanel: LazyAction<typeof lazyIndex.selectGroupInPanel, typeof lazyModule> = new LazyAction(lazyModule, m => m.selectGroupInPanel);

export const lazyOpenGroupsPanel: LazyAction<typeof lazyIndex.openGroupsPanel, typeof lazyModule> = new LazyAction(lazyModule, m => m.openGroupsPanel);

export const lazyInitializeGroupsPanel: LazyAction<typeof lazyIndex.initializeGroupsPanel, typeof lazyModule> = new LazyAction(lazyModule, m => m.initializeGroupsPanel);
